exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul[data-v-0540459a] {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\nul li[data-v-0540459a] {\n    border-bottom: 1px solid #000000;\n}\nul li[data-v-0540459a]:last-child {\n      border: none;\n}\n", ""]);

